module.exports = __webpack_public_path__ + "assets/img/thumbs-up@1,5x.7e5d9ffb.svg";